export default __webpack_public_path__ + "static/cndf-lab1-8807a437ace36185393b0abcc188fb8c.jpg";